import { Plus } from '@remarkable/ark-icons';
import { Typography } from '@remarkable/ark-web';

import pairDeviceWebp from 'src/assets/img/rM_pair_device.webp';
import { URLS } from 'src/utils/urls/urls';

import { Trans, useLingui } from '@lingui/react/macro';
import { Button } from './Button';
import { StackedSheet } from './StackedSheet';

export const WelcomeAndPairDeviceHero = () => {
  const { t } = useLingui();
  return (
    <StackedSheet dataCy="pair-device-hero">
      <div className="flex flex-col gap-32 text-left lxl:flex-row lxl:gap-0">
        <div className="m-auto flex flex-col gap-0 lxl:w-1/2">
          <Typography variant="responsive-heading-xl" className="mb-24">
            <Trans>Pair your device</Trans>
          </Typography>
          <Typography className="mb-32" variant="body-md">
            <Trans>
              Add your device to your reMarkable account to make sure you get
              cloud backup, and access to your work with our apps. New users can
              also claim their free Connect trial.
            </Trans>
          </Typography>
          <Button
            as="a"
            variant="primary"
            className="w-full lm:w-fit"
            to={URLS.DEVICE_REMARKABLE_CONNECT}
            data-cy="pair-device-button"
          >
            <span>
              <Trans>Pair device</Trans>
            </span>{' '}
            <Plus />
          </Button>
        </div>
        <img
          src={pairDeviceWebp}
          className="max-h-[340px] object-cover lxl:w-1/2 lxl:pl-32"
          alt={t`Pair Paper Tablet with your account`}
        />
      </div>
    </StackedSheet>
  );
};
